import React from 'react';
import styled from 'styled-components';

const EmptyList = () => {
  return (
    <Wrapper>
      <h2>Cogniters are starving! </h2>
      <h3>There is no food in the menu :(</h3>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 30px;
  color: #ffffff;
  text-align: center;
  width: 100%;
`;

export default EmptyList;
